"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioInnerDot = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _RadioIcon = require("./RadioIcon");
var _radioTheme = require("./radioTheme");
const RadioInnerDot = (0, _styled.default)("div")`
    background-color: ${_RadioIcon.getBorderColor};
    border-radius: 50%;
    opacity: ${_ref => {
  let {
    isChecked,
    themeMode
  } = _ref;
  return isChecked ? _radioTheme.radioInnerDotTheme.opacity.checked(themeMode) : _radioTheme.radioInnerDotTheme.opacity.unchecked(themeMode);
}};
    height: ${_ref2 => {
  let {
    size
  } = _ref2;
  return size === "large" ? 10 : 8;
}}px;
    width: ${_ref3 => {
  let {
    size
  } = _ref3;
  return size === "large" ? 10 : 8;
}}px;

    // We don't want this to affect the hover/active/etc. states.
    pointer-events: none;
`;
exports.RadioInnerDot = RadioInnerDot;
//# sourceMappingURL=RadioInnerDot.js.map